<template>
  <input
    type="checkbox"
    :value="value"
    v-model="proxyChecked"
    class="border border-gray-100 bg-transparent rounded"
  />
</template>

<style scoped>
input {
  width: 20px;
  height: 20px;
}
</style>

<script>
export default {
  emits: ['update:checked'],

  props: {
    checked: {
      type: [Array, Boolean],
      default: false
    },
    value: {
      default: null
    }
  },

  computed: {
    proxyChecked: {
      get() {
        return this.checked
      },

      set(val) {
        this.$emit('update:checked', val)
      }
    }
  }
}
</script>
